import React, { useState, useEffect } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import toast from 'react-hot-toast'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'

const EditExamSheet = ({ show, handleClose, examData, refreshExamsData }) => {
  const [updatedExam, setUpdatedExam] = useState({
    course_id: '',
    exam_name: '',
    exam_location: '',
    start_date: '',
    end_date: '',
    status: '',
    marking_scheme: '',
    passing_marks: '',
    total_marks: '',
  })
  const [courses, setCourses] = useState([])

  useEffect(() => {
    if (examData) {
      setUpdatedExam({
        course_id: examData.course_id || '',
        exam_name: examData.exam_name || '',
        exam_location: examData.exam_location || '',
        start_date: examData.start_date?.substring(0, 10) || '',
        end_date: examData.end_date?.substring(0, 10) || '',
        status: examData.status || '',
        marking_scheme: examData.marking_scheme || '',
        passing_marks: examData.passing_marks || '',
        total_marks: examData.total_marks || '',
      })
    }
  }, [examData])
  useEffect(() => {
    ApiEndpoints.getAllCourses().then((res) => setCourses(res.data.data))
  }, [])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setUpdatedExam((prev) => ({ ...prev, [name]: value }))
  }

  const handleSaveChanges = async () => {
    try {
      const response = await ApiEndpoints.editExam(examData.id, updatedExam)
      toast.success(response.data.message)

      if (typeof refreshExamsData === 'function') {
        await refreshExamsData()
      }
      handleClose()
    } catch (error) {
      toast.error(error.response?.data?.message)
    }
  }

  return (
    <Modal show={show} onHide={handleClose} centered size='lg'>
      <Modal.Header closeButton 
        closeVariant="white"
        className="bg-warning text-dark">
        <Modal.Title>Edit Exam</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Course</Form.Label>
            <Form.Select
              name="course_id"
              value={updatedExam.course_id}
              onChange={handleInputChange}
            >
              <option value="">Select Course</option>
              {courses.map((course) => (
                <option key={course.id} value={course.id}>
                  {course.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3 text-start">
            <Form.Label>Exam Name</Form.Label>
            <Form.Control
              type="text"
              name="exam_name"
              value={updatedExam.exam_name}
              onChange={handleInputChange}
              placeholder="Enter Exam Name"
            />
          </Form.Group>
          <Form.Group className="mb-3 text-start">
            <Form.Label>Location</Form.Label>
            <Form.Control
              type="text"
              name="exam_location"
              value={updatedExam.exam_location}
              onChange={handleInputChange}
              placeholder="Enter Exam Location"
            />
          </Form.Group>
          <Form.Group className="mb-3 text-start">
            <Form.Label>Marking Scheme</Form.Label>
            <Form.Control value={updatedExam.marking_scheme || ''} disabled />
          </Form.Group>

          <Form.Group className="mb-3 text-start">
            <Form.Label>Passing Marks</Form.Label>
            <Form.Control
              type="number"
              name="passing_marks"
              value={updatedExam.passing_marks || ''}
              onChange={handleInputChange}
              placeholder="Enter Passing Marks"
            />
          </Form.Group>

          <Form.Group className="mb-3 text-start">
            <Form.Label>Total Marks</Form.Label>
            <Form.Control
              type="number"
              name="total_marks"
              value={updatedExam.total_marks || ''}
              onChange={handleInputChange}
              placeholder="Enter Total Marks"
            />
          </Form.Group>

          <Form.Group className="mb-3 text-start">
            <Form.Label>Start Date</Form.Label>
            <Form.Control
              type="date"
              name="start_date"
              value={updatedExam.start_date}
              onChange={handleInputChange}
            />
          </Form.Group>

          <Form.Group className="mb-3 text-start">
            <Form.Label>End Date</Form.Label>
            <Form.Control
              type="date"
              name="end_date"
              value={updatedExam.end_date}
              onChange={handleInputChange}
            />
          </Form.Group>

          <Form.Group className="mb-3 text-start">
            <Form.Label>Status</Form.Label>
            <Form.Select
              name="status"
              value={updatedExam.status}
              onChange={handleInputChange}
            >
              <option value="">Select Status</option>
              <option value="upcoming">Upcoming</option>
              <option value="ongoing">Ongoing</option>
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="warning" onClick={handleSaveChanges}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default EditExamSheet
